import React, { SyntheticEvent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { cloneDeep } from "lodash";
import { defineMessages, FormattedMessage } from "react-intl";
import { asUTC } from "../lib/dateUtils";

const messages = defineMessages({
  yes: {
    id: "default.yes",
    defaultMessage: "Yes",
  },
  no: {
    id: "default.no",
    defaultMessage: "No",
  },
});

const StyledPillContainer = styled.span`
  font-size: 14px;
  min-width: 0;
  line-height: 27px;
`;

const IconContainer = styled.span`
  min-width: 22px;
  padding: 5px;
`;

const StyledPill = styled.span`
  background-color: rgb(230, 230, 230);
  white-space: nowrap;
  min-width: 0;
  box-sizing: border-box;
  border-radius: 2px;
  margin: 2px;
  padding: 3px 3px 3px 6px;
`;

const StyledPillKeyValue = styled.span`
  color: rgb(51, 51, 51);
  font-size: 85%;
  box-sizing: border-box;
  border-radius: 2px;
  overflow: hidden;
`;

interface DateObject {
  start?: string;
  end?: string;
  startDate?: string;
  endDate?: string;
}
export interface FilterValues {
  [key: string]: string | boolean | DateObject | undefined;
}

export default function filterPills(
  filterValues: FilterValues,
  labels: { [key: string]: string } | undefined,
  updateFunction?: (value: any) => void,
  updateTempFunction?: (value: any) => void
) {
  const handleRemoveFilter = (event: SyntheticEvent, filter: string) => {
    event.stopPropagation();

    const filterValuesClone = cloneDeep(filterValues);
    if (typeof filterValuesClone[filter] === "string") {
      filterValuesClone[filter] = "";
    }
    if (typeof filterValuesClone[filter] === "object") {
      if (
        (filterValuesClone[filter] as DateObject).startDate &&
        (filterValuesClone[filter] as DateObject).endDate
      ) {
        (filterValuesClone[filter] as DateObject).startDate = "";
        (filterValuesClone[filter] as DateObject).endDate = "";
      }
      if (
        (filterValuesClone[filter] as DateObject).start &&
        (filterValuesClone[filter] as DateObject).end
      ) {
        (filterValuesClone[filter] as DateObject).start = "";
        (filterValuesClone[filter] as DateObject).end = "";
      }
    }
    if (typeof filterValuesClone[filter] === "boolean") {
      filterValuesClone[filter] = undefined;
    }

    if (typeof updateFunction === "function") {
      updateFunction(filterValuesClone);
    }
    if (typeof updateTempFunction === "function") {
      updateTempFunction(filterValuesClone);
    }
  };
  return (
    <StyledPillContainer>
      {labels &&
        filterValues &&
        Object.entries(filterValues).map((filter, idx) => {
          if (typeof filter[1] === "string" && filter[1]) {
            return (
              <StyledPill key={idx}>
                <StyledPillKeyValue>
                  <span>
                    {labels[filter[0]] && <>{labels[filter[0]]}:&nbsp;</>}
                    {filter[1] === "true" ? (
                      <FormattedMessage {...messages.yes} />
                    ) : filter[1] === "false" ? (
                      <FormattedMessage {...messages.no} />
                    ) : (
                      filter[1]
                    )}
                  </span>
                </StyledPillKeyValue>
                <IconContainer onClick={event => handleRemoveFilter(event, filter[0])}>
                  <FontAwesomeIcon icon={faTimes} />
                </IconContainer>
              </StyledPill>
            );
          }

          if (
            filter[1] &&
            typeof filter[1] === "object" &&
            (filter[1].startDate || filter[1].start || filter[1].endDate || filter[1].end)
          ) {
            let startDate;
            let endDate;
            if (filter[1].startDate || filter[1].start) {
              //@ts-ignore
              startDate = asUTC(new Date(filter[1].startDate || filter[1].start));
            }
            if (filter[1].endDate || filter[1].end) {
              //@ts-ignore
              endDate = asUTC(new Date(filter[1].endDate || filter[1].end));
            }
            return (
              <StyledPill>
                <StyledPillKeyValue>
                  <span>
                    {" "}
                    {labels[filter[0]]}: &nbsp;{startDate} - {endDate}
                  </span>
                </StyledPillKeyValue>
                <IconContainer onClick={event => handleRemoveFilter(event, filter[0])}>
                  <FontAwesomeIcon icon={faTimes} />
                </IconContainer>
              </StyledPill>
            );
          }

          if (typeof filter[1] === "boolean") {
            return (
              <StyledPill>
                <StyledPillKeyValue>
                  <span>
                    {labels[filter[0]]}:&nbsp;
                    {filter[1] ? (
                      <FormattedMessage {...messages.yes} />
                    ) : (
                      <FormattedMessage {...messages.no} />
                    )}{" "}
                  </span>
                </StyledPillKeyValue>
                <IconContainer onClick={event => handleRemoveFilter(event, filter[0])}>
                  <FontAwesomeIcon icon={faTimes} />
                </IconContainer>
              </StyledPill>
            );
          }
          return null;
        })}
    </StyledPillContainer>
  );
}
